import { call, delay, put, race } from 'redux-saga/effects';
import {
  fetchBonusesContentFail,
  fetchBonusesContentSuccess,
} from '../../../actions/domain/bonuses';
import { getBonusesContent } from '../../api';
import { FETCH_DELAY_TIMEOUT } from '../../../constants/sagas';

export function* loadBonusesContent() {
  try {
    const { response, timeout } = yield race({
      response: call(getBonusesContent),
      timeout: delay(FETCH_DELAY_TIMEOUT),
    });

    if (timeout) {
      return yield put(fetchBonusesContentFail());
    }

    yield put(fetchBonusesContentSuccess(response));
  } catch (e) {
    yield put(fetchBonusesContentFail(e));
  }
}
